import { render, staticRenderFns } from "./PainelComTabsSemRotas.vue?vue&type=template&id=66f439c4&scoped=true"
import script from "./PainelComTabsSemRotas.vue?vue&type=script&lang=js"
export * from "./PainelComTabsSemRotas.vue?vue&type=script&lang=js"
import style0 from "./PainelComTabsSemRotas.vue?vue&type=style&index=0&id=66f439c4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f439c4",
  null
  
)

export default component.exports